import React from 'react';
import { readReraPdfFile } from '../../Services/SmsService';
import Button from '../../Subcomponents/Button';
import * as XLSX from "xlsx";
import { supabase } from '../../supabaseClient';
import { signUpStaticCP } from '../../Services/LoginService';

const Scripts = () => {
    function getReraType() {
        readReraPdfFile('https://pufucoawlndmgmkuflpx.supabase.co/storage/v1/object/public/kycdocuments/CpDocuments/97d651db-d46f-4c34-b39f-0f2ec370ac4e_rera.pdf')
            .then((resp) => {
                console.log(resp);
                // ??to find Rera type
                let responseObject = resp?.data?.pdf?.pages[0]?.texts.find(
                    (data, index) => {
                        if (index === 0) return false;
                        return (
                            resp?.data?.pdf?.pages[0]?.texts[index - 1].text ==
                            "Information Type"
                        );
                    }
                )?.text;
                console.log('response obj', responseObject);
                let responseObject2 = null;
                if (responseObject === undefined) {
                    responseObject2 = resp?.data?.pdf?.pages[1]?.texts.find(
                        (data, index) => {
                            if (index === 0) return false;
                            return (
                                resp?.data?.pdf?.pages[1]?.texts[index - 1]?.text ==
                                "Information Type"
                            );
                        }
                    )?.text;
                }
                console.log('response obj 2', responseObject2);

                if (responseObject === "Other Than Individual" || responseObject2 === "Other Than Individual") {
                    console.log('CP type: ', "Entity");
                } else {
                    console.log('CP type: ', "Individual");
                }
            })
            .catch((err) => {
                console.log('Error in reading rera doc', err);
            });
    }
    const fileSelectForUpload = (e) => {
        const _file = e.target.files[0];
        console.log({ _file });
        const reader = new FileReader();
        reader.onload = async function (e) {
            console.log(e);
            var data = e.target.result;
            data = new Uint8Array(data);
            var workbook = XLSX.read(data, {
                type: "array",
                cellText: false,
                cellDates: true,
            });
            var roa;
            workbook.SheetNames.forEach(function (sheetName) {
                roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
            });
            console.log({ roa });
            updateReraType(roa)
        }
        reader.readAsArrayBuffer(_file);
    };
    async function updateReraType(cpArr) {
        let rejectCP = [];
        let validCP = [];
        let index = 0;
        let count = 0;
        for (const cpEle of cpArr) {
            if (index === 1) {
                break;
            }
            index++;
            // eslint-disable-next-line no-loop-func
            await supabase.from('CP').update({ cpType: cpEle.cpType }).eq('cpDisplayId', cpEle.cpDisplayId).then((resp) => {
                console.log('resp: ', resp);
                count++;
                validCP.push(cpEle);
            }).catch((err) => {
                console.log('err: ', err);
                rejectCP.push(cpEle);
            });
        }
        if (validCP.length > 0) {
            downloadExcel(validCP, 'CP Type Updated')
        }
        if (rejectCP.length > 0) {
            downloadExcel(rejectCP, 'CP Type Update Failed')
        }
    }
    function downloadExcel(arr, filename) {
        const worksheet = XLSX.utils.json_to_sheet(arr);
        const workBook = new XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, worksheet, "duplicates");
        XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        XLSX.writeFile(workBook, filename + ".xlsx");
    }
    function signUpCp() {
        signUpStaticCP().then((resp) => {
            console.log('sign up static cp resp: ', resp);
        }).catch((err) => {
            console.log('err: ', err);
        });
    }
    return (
        <div>
            <div>
                <Button
                    style={{
                        color: "#155EEF",
                        backgroundColor: "#ffffff",
                        border: "1px solid #155EEF",
                    }}
                    btnName={"Sign Up Static CP"}
                    clicked={signUpCp}
                />
            </div>
            {/* <div>
                <Button
                    style={{
                        color: "#155EEF",
                        backgroundColor: "#ffffff",
                        border: "1px solid #155EEF",
                    }}
                    btnName={"Get RERA type"}
                    clicked={getReraType}
                />
            </div> */}
        </div>
    );
}

export default Scripts;
